import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import { Button } from "../PicturesLoadedStyled";

const PrimaryAction = ({ pictures, sendPictures, doneWithPictures }) => {
  const sendPicturesAndFinish = () => {
    sendPictures();
    doneWithPictures();
  };
  const t = useTranslate();
  let textContent = t("upload_photos_preview_card-button_3");
  let actionProps = {
    "data-action": "done_button-click",
    onClick: doneWithPictures,
    "data-testid": "upload_photos-button_done"
  };
  const hasPendingPictures = pictures.find(
    picture => picture.status !== "SENT"
  );
  const hasSentPictures = pictures.find(picture => picture.status === "SENT");

  if (hasPendingPictures) {
    textContent = t("upload_photos_preview_card-button_1");
    actionProps = {
      "data-action": hasSentPictures ? "" : "send_button-click",
      onClick: sendPicturesAndFinish,
      disabled: pictures.length === 0,
      "data-testid": "upload_photos-button_upload"
    };
  }
  return <Button {...actionProps}>{textContent}</Button>;
};

export default PrimaryAction;
